export default "__VITE_ASSET__B9sBVwtG__"